import { useEffect, useReducer, useState } from "react";
import { useSearchParams } from "react-router-dom";
import dtReducer from "./util/reducer";
import DtToolbar from "./compoents/toolbar";
import Paginator from "../paginator";
import Search from "../search";
import DtCell from "./compoents/cell";
import { Actions } from "./util/actions";
import { Checkbox, Radio } from "flowbite-react";
import { ACL } from "../acl";
const ascending_icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="#374151"
    className="w-4 h-4 ml-3"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4.5 10.5L12 3m0 0l7.5 7.5M12 3v18"
    />
  </svg>
);

const descending_icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="#3F83F8"
    className="w-4 h-4 ml-3"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.5 13.5L12 21m0 0l-7.5-7.5M12 21V3"
    />
  </svg>
);

const default_sort_icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="#3741516f"
    className="w-4 h-4 ml-3"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 7.5L7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
    />
  </svg>
);
const Defaults = {
  paginator: {
    pageLimit: 10,
    limits: [5, 10, 15],
  },
  dateFormat: "DD-MM-YYYY",
};
function DataTable({
  id,
  name,
  columns,
  data,
  totalCount,
  layout = "auto",
  dateFormat,
  enableSort,
  indexField,
  onRowClick,
  handleFetch,
  remote = true,
  toolbar,
  rowSelection = {},
  footer,
  preserve,
  syncWithUrl = false,
  className = ''
}) {
  if (!remote) totalCount = data?.length;
  const [searchParams, setSearchParams] = useSearchParams();
  const _savedParams = JSON.parse(localStorage.getItem(`dt_params_${name}`));
  const urlPage = syncWithUrl ? parseInt(searchParams.get("page")) || null : null;
  const initialState = {
    page: footer?.paginator?.enable
      ? urlPage || footer?.paginator?.initialPage || _savedParams?.page || 1
      : null,
    pageLimit: footer?.paginator.enable
      ? footer?.paginator.initialLimit || Defaults.paginator.pageLimit
      : null,
    sortBy: null,
    sortDir: null,
    keyword: toolbar?.search?.enable
      ? toolbar?.search?.initialKeyword || _savedParams?.keyword || null
      : null,
    filter:
      toolbar?.filter?.enable && toolbar?.filter?.initialValue
        ? toolbar.filter.initialValue
        : null,
  };

  const [dtState, dispatch] = useReducer(dtReducer, initialState);
  const [selectedRows, setSelectedRows] = useState(rowSelection?.initial || []);
  const [displayData, setDisplayData] = useState([]);
  if (rowSelection.enable) {
    rowSelection.type = "selection";
    columns =
      rowSelection.position === "start"
        ? [rowSelection, ...columns]
        : [...columns, rowSelection];
  }
  useEffect(() => {
    // Sync page with URL query params if enabled
    if (syncWithUrl && dtState.page) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set("page", dtState.page);
      setSearchParams(newParams, { replace: true });
    }

    if (preserve) {
      let to_preserve = {};
      if (preserve === "all") {
        to_preserve = { ...dtState };
      } else if (typeof preserve === "string") {
        to_preserve = { [preserve]: dtState[preserve] };
      } else if (Array.isArray(preserve)) {
        to_preserve = preserve.reduce(
          (acc, val) => ({
            ...acc,
            [val]: dtState[val],
          }),
          {}
        );
      }
      try {
        localStorage.setItem(
          `dt_params_${id || name}`,
          JSON.stringify(to_preserve)
        );
      } catch (e) {}
    }
    if (remote && handleFetch) handleFetch({ ...dtState });
  }, [dtState, syncWithUrl]);

  useEffect(() => {
    if (!remote) {
      let temp;
      temp = data?.filter((_d) => {
        if (dtState.keyword) {
          return new RegExp(dtState.keyword.toLowerCase()).test(
            _d[toolbar?.search?.searchBy]?.toLowerCase()
          );
        } else return true;
      });
      if (footer?.paginator?.enable) {
        temp = temp?.slice(
          (dtState.page - 1) * dtState.pageLimit,
          dtState.page * dtState.pageLimit - 1 >= data?.length
            ? data?.length
            : dtState.page * dtState.pageLimit
        );
      }
      setDisplayData(temp);
    }
  }, [dtState, data]);
  const handleSort = (col) => {
    console.log(
      !enableSort ||
        col.type === "actions" ||
        col.type === "selection" ||
        col.disableSort
    );
    if (
      !enableSort ||
      col.type === "actions" ||
      col.type === "selection" ||
      col.disableSort
    ) {
      return;
    }
    if (dtState.sortBy === col.key)
      if (dtState.sortDir === "DESC")
        dispatch(Actions.SORT({ sortDir: null, sortBy: null }));
      else dispatch(Actions.SORT({ sortDir: "DESC", sortBy: col.key }));
    else dispatch(Actions.SORT({ sortDir: "ASC", sortBy: col.key }));
  };

  const handleRowClick = (e, row) => {
    e.preventDefault();
    if (onRowClick) onRowClick(row);
  };

  const handleRowSelect = (row, checked) => {
    let temp;
    if (rowSelection.multi) {
      if (checked) {
        temp = [...selectedRows, row];
      } else {
        temp = selectedRows.filter((_item) => {
          return _item[indexField] !== row[indexField];
          // const keysA = Object.keys(_item);
          // const keysB = Object.keys(row);
          // if (keysA.length !== keysB.length) {
          //   return true;
          // }
          // for (let key of keysA) {
          //   if (!row.hasOwnProperty(key) || _item[key] !== row[key]) {
          //     return true;
          //   }
          // }
          // return false;
        });
      }
    } else {
      if (selectedRows && selectedRows[indexField] === row[indexField])
        temp = null;
      else temp = row;
    }
    setSelectedRows(temp);
    rowSelection.onRowSelect &&
      rowSelection.onRowSelect({
        selectedRows: temp,
        current: row,
        is_selected: checked,
      });
  };

  const isRowSelected = (row) => {
    return !!selectedRows.find((_item) => {
      return _item[indexField] === row[indexField];
      // const keysA = Object.keys(_item);
      // const keysB = Object.keys(row);
      // if (keysA.length !== keysB.length) {
      //   return false;
      // }
      // for (let key of keysA) {
      //   if (!row.hasOwnProperty(key) || _item[key] !== row[key]) {
      //     return false;
      //   }
      // }
      // return true;
    });
  };

  const resolveTH = (col) => {
    return col.type === "selection" ? (
      <th
        scope="col"
        key={"selection-" + col.name}
        className="cursor-pointer py-3.5 pl-4 pr-3 text-left text-sm font-semibold  sm:pl-0"
      >
        {col.showSelectAll && (
          <Checkbox
            checked={selectedRows.length === data.length}
            className="cursor-pointer mr-2"
          />
        )}
        {col.name}
      </th>
    ) : (
      <th
        key={col.key + "-" + col.name}
        onClick={() => {
          handleSort(col);
        }}
        scope="col"
        className={`
        ${col.align && "[&>div]:justify-" + col.align}
                    ${col.width ? `w-${col.width} ` : "[&>div]:w-auto"}
                    ${
                      col.key === dtState.sortBy
                        ? "text-blue-500"
                        : "text-gray-900"
                    } capitalize ${
                      enableSort &&
                      !col.disableSort &&
                      col.type !== "actions" &&
                      "cursor-pointer"
                    } whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold  sm:pl-0`}
      >
        <div className="flex flex-row">
          <p>{col.name}</p>
          {enableSort &&
            !col.disableSort &&
            col.type !== "actions" &&
            col.type !== "selection" &&
            (!dtState.sortBy || dtState.sortBy === col.key) && (
              <>
                {dtState.sortBy === col.key
                  ? dtState.sortDir === "ASC"
                    ? ascending_icon
                    : descending_icon
                  : default_sort_icon}
              </>
            )}
        </div>
      </th>
    );
  };

  const resolveTD = (col, row, index) => {
    if (col.type === "date")
      return (
        <DtCell.Date
          key={`td-${col.key}-${index}`}
          data={row}
          cellDef={{
            ...col,
            dateFormat: col.dateFormat || Defaults.dateFormat,
          }}
        />
      );
    else if (col.type === "actions")
      return (
        <DtCell.Actions
          key={`td-${col.key}-${index}`}
          data={row}
          cellDef={col}
          dtState={dtState}
        />
      );
    else if (col.type === "custom")
      return (
        <DtCell.Custom
          key={`td-${col.key}-${index}`}
          data={row}
          cellDef={col}
        />
      );
    else if (col.type === "selection") {
      if (rowSelection.multi)
        return (
          <td className="[&>input]:w-5 [&>input]:border-gray-400 [&>input]:text-gray-800 [&>input]:h-5 [&>input:focus]:ring-0 whitespace-nowrap py-3 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
            <Checkbox
              onClick={(e) => {
                e.stopPropagation();
                handleRowSelect(row, e.target.checked);
              }}
              className="cursor-pointer"
              checked={isRowSelected(row)}
            />
          </td>
        );
      else {
        return (
          <td className="[&>input]:w-5 [&>input]:border-gray-400 [&>input]:text-gray-600 [&>input]:h-5 [&>input:focus]:ring-0 whitespace-nowrap py-3 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
            <Radio
              onClick={(e) => {
                e.stopPropagation();
                handleRowSelect(row, e.target.checked);
              }}
              readOnly
              value={row}
              name="selection"
              className="cursor-pointer"
              checked={
                selectedRows && selectedRows[indexField] === row[indexField]
              }
            />
          </td>
        );
      }
    } else
      return (
        <DtCell.Text key={`td-${col.key}-${index}`} data={row} cellDef={col} />
      );
  };

  return (
    <>
      <div className={`grid grid-rows-[auto_1fr_auto] relative p-3 max-h-[80vh] h-full w-full min-w-full overflow-hidden ${className}`}>
        <DtToolbar
          name={name}
          hideCount={toolbar?.hideCount}
          totalCount={
            remote
              ? totalCount
              : dtState.keyword
                ? displayData?.length
                : data?.length
          }
        >
          {toolbar?.leadingAction}
          {toolbar?.search?.enable && (
            <Search
              onSearch={(keyword) => {
                dispatch(Actions.SEARCH(keyword));
              }}
              keyword={dtState.keyword}
              {...toolbar.search}
              name={name}
            />
          )}
          {/* {toolbar?.filter?.enable && (
            <DropDown
              value={toolbar.filter.initialFilter}
              name={toolbar.filter.name}
              className={`text-md w-[155px] h-full `}
              showNull={toolbar.filter.showNull}
              nullLabel={toolbar.filter.nullLabel}
              options={toolbar.filter.options}
              onChange={(v) => {
                dispatch(Actions.FILTER(toolbar.filter.options[v]));
              }}
            />
          )} */}
          {toolbar?.customAction || <></>}
        </DtToolbar>
        {data && (
          <div className="overflow-y-auto">
            <div className="table-auto">
            <table
              className={`w-full h-full divide-y divide-gray-300  ${
                layout === "auto" ? "" : "table-fixed"
              }`}
            >
              <thead className="sticky top-0 bg-white">
                <tr>
                  {columns.map((col) => {
                    if (col.showFor || col.hideFor) {
                      return (
                        <ACL showFor={col.showFor} hideFor={col.hideFor}>
                          {resolveTH(col)}
                        </ACL>
                      );
                    }
                    return resolveTH(col);
                  })}
                </tr>
              </thead>
              <tbody className="divide-y min-h-full divide-gray-200">
                {((remote ? data : displayData) || []).map((row, index) => {
                  return (
                    <tr
                      key={`tr-${index}`}
                      onClick={(e) => {
                        handleRowClick(e, row);
                      }}
                    >
                      {columns.map((col) => {
                        if (col.showFor || col.hideFor) {
                          return (
                            <ACL showFor={col.showFor} hideFor={col.hideFor}>
                              {resolveTD(col, row, index)}
                            </ACL>
                          );
                        }
                        return resolveTD(col, row, index);
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {((remote ? data : dtState.keyword ? displayData : data) || [])
              .length === 0 && (
              // <div className="w-full h-full  flex justify-center items-center text-sm text-gray-500">
              //   No data
              // </div>
              <div className="w-full h-full table-row text-center text-sm text-gray-500">
                <span className="table-cell align-middle"> No data</span>
              </div>
            )}
            </div>
          </div>
        )}
        <div className="table-row bg-white h-[58px]">
          <div className="grid grid-rows-1 grid-flow-col items-center mt-3">
            {footer?.paginator?.enable && (
              <Paginator
                className={`justify-self-${
                  footer.paginator.placement || "end"
                }`}
                page={dtState.page}
                pageLimit={dtState.pageLimit}
                totalCount={
                  remote
                    ? totalCount
                    : dtState.keyword
                      ? displayData?.length
                      : data?.length
                }
                {...footer.paginator}
                onPageChange={(page) => {
                  dispatch(Actions.PAGE(page));
                }}
              />
            )}
            {footer?.customActions}
          </div>
        </div>
      </div>
    </>
  );
}

export { DataTable };
